import api from './api';
import { Propuesta, PaginatedResponse } from '../types';

class ProposalsService {
  async getPropuestas(page = 1, limit = 10, search?: string): Promise<PaginatedResponse<Propuesta>> {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });
    
    if (search) {
      params.append('search', search);
    }

    const response = await api.get<PaginatedResponse<Propuesta>>(`/propuestas?${params}`);
    return response.data;
  }

  async getPropuestaById(id: number): Promise<Propuesta> {
    const response = await api.get<Propuesta>(`/propuestas/${id}`);
    return response.data;
  }

  async createPropuesta(propuesta: Omit<Propuesta, 'id' | 'createdAt' | 'updatedAt'>): Promise<Propuesta> {
    const response = await api.post<Propuesta>('/propuestas', propuesta);
    return response.data;
  }

  async updatePropuesta(id: number, propuesta: Partial<Propuesta>): Promise<Propuesta> {
    const response = await api.put<Propuesta>(`/propuestas/${id}`, propuesta);
    return response.data;
  }

  async deletePropuesta(id: number): Promise<void> {
    await api.delete(`/propuestas/${id}`);
  }

  async uploadFile(file: File): Promise<{ url: string }> {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await api.post<{ url: string }>('/propuestas/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    
    return response.data;
  }

  async generarPdf(id: number, plantilla?: string, regenerar = false): Promise<any> {
    const response = await api.post(`/propuestas/${id}/generar-pdf`, { plantilla, regenerar, preview: false });
    return response.data;
  }

  async generarPdfPreview(id: number, plantilla?: string): Promise<string> {
    const response = await api.post(`/propuestas/${id}/generar-pdf`, 
      { plantilla, preview: true },
      { responseType: 'blob' }
    );
    const blob = new Blob([response.data], { type: 'application/pdf' });
    return URL.createObjectURL(blob);
  }

  async enviarPropuesta(id: number, data: { to: string[]; cc?: string[]; asunto?: string; mensajeHtml?: string; plantilla?: string; regenerar?: boolean }): Promise<any> {
    const response = await api.post(`/propuestas/${id}/enviar`, data);
    return response.data;
  }

  async getPlantillas(): Promise<any[]> {
    const response = await api.get('/propuestas/plantillas');
    return response.data;
  }
}

const proposalsService = new ProposalsService();
export default proposalsService;